export default "__VITE_ASSET__DljwrD4V__"